import { BrowserRouter, Route, Routes } from "react-router-dom";
import PhosphorIconInit from "../helper/PhosphorIconInit";
import RouteScrollToTop from "../helper/RouteScrollToTop";
import { routes } from "./routes";
const AppRouter = () => {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />
      <Routes>
        {routes.map((route) => (
          <Route key={route.id} path={route.path} element={route.element}  />
        ))}
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
